import { PUNCTUALITY_DATE_WISE } from "../constants/apiUrls";
import { makeRequest } from "../shared/fetchData";
import { auth } from "../firebase";

export const fetchStudentPunctualityDateWise = async ({
  queryStartDateTimeUTC,
  queryEndDateTimeUTC,
  studentId,
}) => {
  try {
    const authorization = await auth.currentUser.getIdToken(true);
    const { data } = await makeRequest({
      url: PUNCTUALITY_DATE_WISE,
      method: "POST",
      data: {
        studentId,
        fromDateTime: queryStartDateTimeUTC,
        toDateTime: queryEndDateTimeUTC,
      },
      authorization,
    });
    return Promise.resolve(data.data);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};
